/** Storefront announcement bars. Lengths must match Client/Pipelines/SiteBanners/SiteBannerCatalog.cs. */

export const SITE_BANNER_LABEL_MAX = 40;
export const SITE_BANNER_MESSAGE_MAX = 280;

export interface SiteBannerSlot {
  label: string;
  message: string;
  revision: string;
}

export interface SiteBanners {
  privateClient: SiteBannerSlot;
  standardClient: SiteBannerSlot;
  updatedDate?: string | null;
  updatedByName?: string | null;
}

export function emptySiteBanner(): SiteBannerSlot {
  return { label: "", message: "", revision: "" };
}

export function emptySiteBanners(): SiteBanners {
  return { privateClient: emptySiteBanner(), standardClient: emptySiteBanner() };
}

function field(source: Record<string, unknown>, name: string): unknown {
  if (name in source) return source[name];
  const pascal = name.charAt(0).toUpperCase() + name.slice(1);
  return source[pascal];
}

function readSlot(value: unknown): SiteBannerSlot {
  if (!value || typeof value !== "object") return emptySiteBanner();
  const source = value as Record<string, unknown>;
  const label = field(source, "label");
  const message = field(source, "message");
  const revision = field(source, "revision");
  return {
    label: typeof label === "string" ? label : "",
    message: typeof message === "string" ? message : "",
    revision: typeof revision === "string" ? revision : "",
  };
}

export function readSiteBanners(data: unknown): SiteBanners {
  if (!data || typeof data !== "object") return emptySiteBanners();
  const source = data as Record<string, unknown>;
  const updatedDate = field(source, "updatedDate");
  const updatedByName = field(source, "updatedByName");
  return {
    privateClient: readSlot(field(source, "privateClient")),
    standardClient: readSlot(field(source, "standardClient")),
    updatedDate: typeof updatedDate === "string" ? updatedDate : null,
    updatedByName: typeof updatedByName === "string" ? updatedByName : null,
  };
}

export function toSiteBannersPayload(banners: SiteBanners) {
  return {
    privateClient: { label: banners.privateClient.label, message: banners.privateClient.message },
    standardClient: { label: banners.standardClient.label, message: banners.standardClient.message },
  };
}
